<template>
  <div class="w-full h-full bg-white">
    <div class="show-pc">
      <LoadingControl v-if="loading" class="w-full" />
      <div v-else class="h-full w-full relative">
        <div
          v-if="customText"
          class="flex items-center justify-center h-full disabled font-medium select-none"
        >
          {{ customText }}
        </div>
        <div v-else class="flex items-center justify-center h-full">
          <EnterIcon class="w-12" :disabled="disabledEnter" color="#433EFF" />
          <span v-if="portalView" class="font-bold text-sm enter">Back</span>
          <span
            v-else
            :class="['font-bold text-sm enter select-none', disabledEnter ? 'disabled' : '']"
            >Enter</span
          >
        </div>
      </div>
    </div>
    <div class="show-mb flex items-center justify-between h-full w-full relative">
      <!-- meun -->
      <div class="flex-1" @click.stop="$emit('menu')" @touchstart.stop>
        <MenuIcom class="mx-auto" />
      </div>
      <!-- enter -->
      <div
        v-if="customText"
        class="flex-2 flex items-center justify-center h-full disabled font-medium select-none"
      >
        {{ customText }}
      </div>
      <div v-else class="flex-2 h-full active:bg-gray-200 rounded-md flex items-center">
        <LoadingControl v-if="loading" class="mx-auto" />
        <EnterIcon v-else class="w-12 bg-transparent mx-auto" :disabled="disabledEnter" />
      </div>
      <!-- setting -->
      <div class="flex-1 w-full">
        <div v-if="!isMultifunctionMenuHide" @click.stop="$emit('setting')">
          <v-popover class="w-full" trigger="click" :open.sync="transitPopoverVisible">
            <SettingIcon class="mx-auto" :visible="transitPopoverVisible" />
            <template #popover>
              <div>
                <div class="meun-button" @click="$emit('openReport')">
                  <div class="mr-1">
                    <ReportIcon class="w-6 h-6" />
                  </div>
                  <span>学习报告</span>
                </div>
                <div class="meun-button" @click="handleCheckNote">
                  <div class="mr-1">
                    <CheckNoteIcon class="w-6 h-6" />
                  </div>
                  <span>查看笔记</span>
                </div>
                <div class="meun-button" @click="handleRelearn">
                  <div class="mr-1">
                    <RelearnIcon class="w-6 h-6" />
                  </div>
                  <span>重新学习</span>
                </div>
                <div v-if="!isPublic" class="meun-button" @click="handleExitLearn">
                  <div class="m-px mr-1">
                    <ExitIcon class="w-5 h-5" />
                  </div>
                  <span>退出学习</span>
                </div>
              </div>
            </template>
          </v-popover>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import MenuIcom from '../assets/MenuIcon.vue';
import SettingIcon from '../assets/SettingIcon.vue';
import LoadingControl from '../assets/LoadingControl.vue';
import EnterIcon from '../assets/EnterIcon.vue';
import CheckNoteIcon from '../assets/CheckNote.vue';
import RelearnIcon from '../assets/Relearn.vue';
import ReportIcon from '../assets/Report.vue';
import ExitIcon from '../assets/Exit.vue';
import { namespace } from 'vuex-class';
const commonModule = namespace('common');

@Component({
  components: {
    MenuIcom,
    SettingIcon,
    LoadingControl,
    EnterIcon,
    CheckNoteIcon,
    RelearnIcon,
    ReportIcon,
    ExitIcon
  }
})
export default class YuanDan extends Vue {
  @Prop({ type: Boolean }) loading: boolean;
  @Prop({ type: String }) customText: string;
  @Prop({ type: Boolean }) disabledEnter: boolean;
  @Prop({ type: Boolean }) popoverVisible: boolean;

  @commonModule.State('isPublic') public isPublic: number;
  @commonModule.Getter('isMultifunctionMenuHide') isMultifunctionMenuHide!: boolean;

  get portalView() {
    const portalSequence = this.$store.state.common.portalSequence;
    return portalSequence[portalSequence.length - 1];
  }
  transitPopoverVisible = false;
  @Watch('_popoverVisible')
  popoverVisibleChange() {
    this.$emit('update:popoverVisible', this.transitPopoverVisible);
  }
  mounted() {
    this.transitPopoverVisible = this.popoverVisible;
  }

  // 查看笔记
  handleCheckNote() {
    this.transitPopoverVisible = false;
    this.$store.dispatch('note/open');
  }
  // 重新学习
  handleRelearn() {
    this.transitPopoverVisible = false;
    this.$emit('relearn');
  }
  // 退出学习
  handleExitLearn() {
    this.$PostConnection?.command('redirect_course');
  }
}
</script>
<style scoped>
.show-pc {
  @apply hidden md:flex h-full;
}
.show-mb {
  @apply flex md:hidden;
}
.flex-2 {
  flex: 2;
}
.show-pc .disabled {
  @apply text-motif-200;
  /* color: #9faad2 !important; */
}

.enter {
  @apply text-motif-500;
}
.meun-button {
  @apply relative flex items-center justify-center cursor-pointer hover:opacity-80 py-2 select-none;
}
.meun-button:first-child {
  @apply pt-0;
}
.meun-button:last-child {
  @apply pb-0;
}
.meun-button::after {
  @apply absolute bottom-0 left-1/2 h-px w-full;
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateX(-50%);
  content: ' ';
}
.meun-button:last-child::after {
  @apply hidden;
  content: '';
}
.hr {
  @apply h-px my-2;
  background-color: rgba(255, 255, 255, 0.2);
}
</style>
